// SearchContainer.jsx
import React, { useEffect } from "react";
import { Row, Col, Button, Spinner } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import queryString from "query-string";
import CustomCard from "../components/CustomCard";
import { GiArmoredBoomerang } from "react-icons/gi";

const SearchContainer = ({ data, handleSearch, handleLoadMore, isLoadMore }) => {
  const location = useLocation();
  const search = queryString.parse(location?.search);

  useEffect(() => {
    if (!data?.items) {
      handleSearch(search?.query);
    }
  }, []);

  return (
    <>
      <Row className="mt-5">
        {data?.items?.map((item, index) => {
          if (item?.id?.kind !== "youtube#video") return null;

          const { title, thumbnails, channelTitle, publishedAt } = item.snippet;
          return (
            <Col xs={12} sm={6} md={4} lg={3} key={`${title}_${index}`} className="mb-4 d-flex">
              <Link to={`/download?query=${item?.id?.videoId}`} className="d-flex w-100 text-decoration-none text-dark">
                <CustomCard 
                    image={thumbnails?.high?.url} 
                    title={title} 
                    channelTitle={channelTitle}
                    publishedAt={publishedAt}
                />
              </Link>
            </Col>
          );
        })}
      </Row>

      {data?.items?.length > 0 && data?.nextPageToken && (
        <Row className="mb-5">
          <Col className="text-center">
            <Button
              size="lg"
              variant="danger"
              className="w-50 fw-bold"
              onClick={handleLoadMore}
              disabled={isLoadMore}
            >
              {!isLoadMore ? (
                <>
                  Load more <GiArmoredBoomerang className="ms-1" />
                </>
              ) : (
                <>
                  Loading...
                  <Spinner animation="border" variant="light" size="sm" className="ms-2" />
                </>
              )}
            </Button>
          </Col>
        </Row>
      )}
    </>
  );
};

export default SearchContainer;
